export default function (props: any) {
    return (
        <svg width="14px" height="9px" viewBox="0 0 14 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="DELTA-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="M端-EU版本" transform="translate(-310.000000, -380.000000)" fill="#757575">
                    <g id="编组-2" transform="translate(35.000000, 357.000000)">
                        <path
                            d="M287.095241,20.4156824 L287.568075,28.6357978 C287.598205,29.1596025 287.198002,29.6086553 286.674198,29.6387854 C286.637858,29.6408757 286.601427,29.6408757 286.565087,29.6387854 L278.344972,29.1659513 C277.821167,29.1358212 277.420965,28.6867684 277.451095,28.1629637 C277.464481,27.9302551 277.562954,27.7105894 277.727776,27.5457676 L285.475057,19.7984863 C285.846055,19.4274882 286.447562,19.4274882 286.81856,19.7984863 C286.983382,19.9633081 287.081855,20.1829738 287.095241,20.4156824 Z"
                            id="矩形"
                            transform="translate(281.929289, 24.000000) rotate(-315.000000) translate(-281.929289, -24.000000) "
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
